import { RequestStatus } from "../../request";

export interface AuthenticationState {
  signInRequestState: RequestStatus;
  signUpRequestState: RequestStatus;
  accountDetailsRequestState: RequestStatus;
  changePasswordRequestState: RequestStatus;
  fetchBalanceRequestState: RequestStatus;
  couponRedeemRequestState: RequestStatus;
  accountInfo: AccountInfo | null;
  couponAmountRemaining: number | null;
  hasUsedCoupon: boolean;
}

export const initialState: AuthenticationState = {
  signInRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  signUpRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  accountDetailsRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  changePasswordRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  fetchBalanceRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  couponRedeemRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  accountInfo: null,
  couponAmountRemaining: null,
  hasUsedCoupon: true,
};

export function Authentication(state = initialState, action: any) {
  switch (action.type) {
    case "authentication-update-sign-in-request-state":
      return {
        ...state,
        signInRequestState: action.requestState,
      };
    case "authentication-update-sign-up-request-state":
      return {
        ...state,
        signUpRequestState: action.requestState,
      };
    case "authentication-update-account-info-persist-request-state":
      return {
        ...state,
        accountDetailsRequestState: action.requestState,
      };
    case "authentication-update-fetch-balance-request-state":
      return {
        ...state,
        fetchBalanceRequestState: action.requestState,
      };
    case "authentication-update-redeem-coupon-request-state":
      return {
        ...state,
        couponRedeemRequestState: action.requestState,
      };
    case "authentication-update-change-password-request-state":
      return {
        ...state,
        changePasswordRequestState: action.requestState,
      };
    case "authentication-update-coupon-remaining":
      return {
        ...state,
        couponAmountRemaining: action.value,
      };
    case "authentication-update-has-used-coupon":
      return {
        ...state,
        hasUsedCoupon: action.hasUsedCoupon,
      };
    case "authentication-update-account-info":
      return {
        ...state,
        accountInfo: action.accountInfo,
      };
    case "reset-data":
      return initialState;
    default:
      return state;
  }
}

export interface AccountInfo {
  partnerId?: number;
  mail: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyStreet: string;
  companyCity: string;
  companyPostalCode: string;
  companyCountry: string;
  companyVatId: string | null;
  apiKey: string;
  showBiddingType: boolean;
  showPlatformSelection: boolean;
  companies: AccountInfoCompany[];
  hasReadOnlyAccess: boolean;
  specialMode?: "main" | "am";
  isROASCampaignsEnabled: boolean;
  isNotificationManagerEnabled: boolean;
}

export interface AccountInfoCompany {
  id: string;
  companyName: string;
}
